import React, {useEffect, useRef, useState} from 'react';
import {observer} from "mobx-react-lite";
import {useWebPSupportCheck} from "react-use-webp-support-check";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FirstSection from "../components/Lottery/FirstSection";
import Filter from "../components/Lottery/Filter";
import {useLocation} from "react-router-dom";
import {useFetching} from "../hooks/useFetching";
import PostService from "../API/PostService";
import {API_LOTTERY_LIST} from "../utils/consts";
import {useObserver} from "../hooks/useObserver";
import Loading from "../components/Loading";
import NoResult from "../components/NoResult";
import LotteryBox from "../components/LotteryBox";

import bgwebp from "../img/bg.webp";
import bgpng from "../img/bg.png";
import Seo from "../components/Seo";

// import image from '../img/lottery/1.gif'

const LotteryPage = () => {
    const {search} = useLocation();
    const searchParams = new URLSearchParams(search);
    const [isLoading, setIsLoading] = useState(false);
    const supportsWebP = useWebPSupportCheck();
    const [list, setList] = useState([]);
    // const [list, setList] = useState([ { id: 1, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 2, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 3, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 4, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 5, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 6, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', } ]);
    const [postLength, setPostLength] = useState(8);
    const [page, setPage] = useState(0);
    const lastElement = useRef(null);

    const [fetchPosts] = useFetching(async (page, searchParams, clearData) => {
        setIsLoading(true);
        try {
            await PostService.getAll(API_LOTTERY_LIST, page, searchParams).then((response) => {
                clearData
                    ? setList(response.data?.list)
                    : setList([...list, ...response.data?.list]);
                setPostLength(response.data.list.length);
                setPage(page + 1);
            });
        } finally {
            setIsLoading(false);
        }
    });

    useObserver(lastElement, postLength >= 8, isLoading, () => {
        if (!isLoading) {
            fetchPosts(page, searchParams, false);
        }
    });

    useEffect(() => {
        if (!isLoading) {
            fetchPosts(0, new URLSearchParams(search), true);
        }
    }, [search]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="container_fluid">
            <Seo page='lottery' />
            <div className="catalog lottery background" style={{backgroundImage: `url(${supportsWebP ? bgwebp : bgpng})`}}>
                <Header />
                <div className="details_content content">
                    <div className="new_games">
                        <FirstSection />
                        <Filter />
                        <div className="row_catalog">
                            <div id="js-scroll_loading" className="boxing_games">
                                {list.length > 0 && list.map(game => <LotteryBox key={game.id} game={game}/>)}
                            </div>
                            <div ref={lastElement} className="lastElement" />
                            {isLoading
                                ? <Loading />
                                : !list.length && <NoResult />}
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default observer(LotteryPage);